import React from 'react';
import { useVideoContext } from '../../../hooks/use-video';
import { Empty, Skeleton } from 'antd';
import {
  Languages,
  SceneAssetItem,
  SceneItemType,
  SceneVoiceoverItem,
  Video,
} from '@monorepo/types';
import { cloneDeep, orderBy } from 'lodash';
import MultiTrackTimeline from '../video-player/new-timeline/multi-track-timeline';
import { buildConfig } from '@monorepo/remotion-ninja';
import { useStore } from '../../../helpers/use-store';

const TimelineContainer = () => {
  const {
    dataStore: { musicStore },
  } = useStore();
  const {
    video,
    playerRef,
    isPlayerReady,
    scenes,
    assets,
    globalScene,
    setPlayerReady,
  } = useVideoContext();

  const music = musicStore.items.find(
    (music) => music._id === video?.backgroundMusicId
  );

  const config = buildConfig({
    backgroundMusicUrl: video?.backgroundMusicUrl
      ? video.backgroundMusicUrl
      : music?.audioUrl,
    backgroundMusicVolume: video?.backgroundMusicVolume,
    subtitlesConfig: video?.subtitlesConfig,
    globalScene,
    video: video as Video,
    scenes,
    assets,
    language: video?.language as Languages,
  });

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '0px',
        left: 0,
        width: '100%',
        zIndex: 999,
      }}
    >
      {isPlayerReady && playerRef.current ? (
        <MultiTrackTimeline playerRef={playerRef.current} config={config} />
      ) : // <VideoTimeline
      //   words={words}
      //   playerRef={playerRef.current}
      //   totalFrames={totalFrames}
      //   fps={30}
      //   images={timelineImages}
      // />
      scenes.length > 0 ? (
        <Skeleton
          style={{
            height: '247px',
            backgroundColor: '#fff',
            borderTop: '1px solid #e3e3e3',
          }}
          active={true}
        />
      ) : (
        <Empty
          description={'Timeline is empty'}
          style={{
            paddingTop: '25px',
            height: '247px',
            backgroundColor: '#fff',
            borderTop: '1px solid #e3e3e3',
          }}
        />
      )}
    </div>
  );
};

export default TimelineContainer;
